import { render, staticRenderFns } from "./InsuranceProviderTable.vue?vue&type=template&id=32477319&"
import script from "./InsuranceProviderTable.vue?vue&type=script&lang=js&"
export * from "./InsuranceProviderTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports